import React from 'react'
import PropTypes from 'prop-types'
import Relazsizes from 'relazsizes'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'

// Image
const BannerImg = ({ src, className }) => (
  <Relazsizes dataSrc={src} alt={src} className={className} />
)

BannerImg.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
}

// Link
const Bannerlink = (props) => {
  const {
    id,
    size,
    onClick,
    recordLead,
  } = props

  if (recordLead) {
    return (
      <AuthenticatedLink
        className={`banner-link-${size}`}
        href={`/banner_action/${id}`}
        onClick={onClick}
        target="blank"
      >
        {props.children}
      </AuthenticatedLink>
    )
  }
    return (
      <a
        className={`banner-link-${size}`}
        href={`/banner_action/${id}`}
        onClick={onClick}
        target="blank"
      >
        {props.children}
      </a>
    )
}

Bannerlink.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['big', 'small']),
  onClick: PropTypes.func,
  recordLead: PropTypes.bool,
}

// Big banner
export const BigBanner = ({ banner }) => (
  <div className="big-banner">
    <BannerImg src={banner.big_image_desktop_url} className="hidden-sm-down" />
    <BannerImg src={banner.big_image_mobile_url} className="hidden-md-up" />
  </div>
)

BigBanner.propTypes = { banner: PropTypes.object.isRequired }

// Small banner
export const SmallBanner = ({ banner }) => (
  <div className="small-banner">
    <BannerImg src={banner.small_image_url} />
  </div>
)

SmallBanner.propTypes = { banner: PropTypes.object }

// Main
const BannerItem = ({ banner, onClick }) => (
  <Bannerlink id={banner.id} recordLead={banner.record_lead} onClick={onClick} size={banner.size}>
    {
      banner.size === 'big'
      ? <BigBanner banner={banner} />
      : <SmallBanner banner={banner} />
    }
  </Bannerlink>
)

BannerItem.propTypes = {
  banner: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default BannerItem
